import { isWebView } from "@benefit-systems/webview";
import { Dispatch } from "react";

import __ from "web/Layout/Translations";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import { setNotificationSuccess } from "web/features/app/appSlice";

type CopyCodeToClipboardArgs = {
  dispatch: Dispatch<unknown>;
  code: string;
};
type CopyCodeToClipboardFn = (args: CopyCodeToClipboardArgs) => void;

const copyCodeToClipboard: CopyCodeToClipboardFn = ({ dispatch, code }) => {
  // fallback for webview and browsers not supporting navigator.clipboard
  if (isWebView() || !navigator?.clipboard) {
    const textarea = document.createElement("textarea");
    textarea.value = code;
    textarea.classList.add("visually-hidden");
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
    } catch (err) {
      newRelicErrorReport(
        err,
        "web-app/Components/Common/CodeItem/CodeModal/utils/copyCodeToClipboard.ts - 29"
      );
      console.error(err);
    }
    document.body.removeChild(textarea);
  } else {
    window.navigator.clipboard.writeText(code);
  }
  dispatch(setNotificationSuccess({ message: __("Kod został skopiowany") }));
};

export default copyCodeToClipboard;
